<template>
    <el-popover
        class="operate-btn notice-btn"
        placement="bottom"
        width="350"
        trigger="click"
        @show="fetchData"
        popper-class="notice-box">
        <div slot="reference" :title="$t('c.noticeHoverTitle')">
            <el-badge :value="total" :hidden="!hasMessage">
                <i class="nucfont inuc-bell"></i>
            </el-badge>
        </div>
        <h3>{{$t('c.noticeTitle')}}</h3>
        <ul v-if="hasMessage" class="notice-list block">
            <transition-group
                name="list"
                enter-active-class="animated fadeInDown"
            >
                <li v-for="(notice, index) in noticeList" @click="confirmNotice(notice, index)" class="notice-item" :key="notice.id">
                    <div style="display: inline; width: 20px; height: 100%; position: absolute; top: 0;">
                        <el-badge :is-dot="true" :hidden="notice.isAcknowledge"></el-badge>
                    </div>
                    <div style="display: inline-block; height: 100%; width: 100%;padding: 10px 0 0 20px;">
                        <p>
                            <i v-if="notice.type==8" class="el-icon-document icon-document"></i>
                            <i v-if="notice.type==10" class="el-icon-caret-right icon-video"></i>
                            <i v-if="notice.type==11" class="nucfont inuc-yinpin icon-audio"></i>
                            <i v-if="notice.type==12" class="el-icon-picture-outline icon-picture"></i>
                            <span style="font-size: 12px">{{notice.message}}</span>
                        </p>
                        <p style="text-align: right; font-size: 12px; color: #909399">{{notice.createTime | formatTime}}</p>
                    </div>
                </li>
            </transition-group>
            <li style="text-align: center">
                <el-pagination
                    layout="prev, pager, next"
                    :total="total"
                    :page-size="5"
                    background
                    small
                    @current-change="currentChange"
                    style="margin: 20px auto 10px;">
                </el-pagination>
            </li>
        </ul>
        <p v-else style="height: 50px;line-height: 50px;text-align: center;border-top: 1px solid rgb(204, 204, 204)">
            {{$t('c.noticeNone')}}
        </p>
        <el-button size="small" v-show="hasMessage" class="clear-notice" @click="emptyNotice()">
            {{$t('c.noticeClear')}}
        </el-button>
    </el-popover>
</template>

<script>
    import api from '@/api';
    import Bus from '@/utils/bus';
    import { mapGetters } from 'vuex'

    export default {
        name: "AppNotice",
        data() {
            return {
                queryData: {
                    PageNO: 1,
                    Limit: -1,
                    Offset: 1
                },
                notices: [],
                total: 0,
                maxRetry: 5,  // 最大重连次数
            }
        },
        mounted () {
            this.getNoticeAmount()
            this.initSignal()
        },
        computed: {
            hasMessage () {
                return this.total > 0
            },
            noticeList () {
                let start = (this.queryData.PageNO - 1) * 5
                let stop = this.queryData.PageNO * 5
                return this.notices.slice(start, stop)
            },
            ...mapGetters([
                'wsBrowser',
            ]),
        },
        methods: {
            fetchData () {
                this.getNoticeList()
            },
            // 连接 signal
            initSignal () {
                this.$store.dispatch('startWSBrowser').then(() => {

                    // 监听消息提示
                    this.wsBrowser.on('LongTaskNoticeReceived', (messageId, data) => {
                        console.log('接收消息>>>', data)
                        let notifOps = {
                            message: data.message,
                            offset: 50
                        }

                        data.success ? this.$notify.success(notifOps) : this.$notify.error(notifOps)

                        // 根据类型，刷新资源库/开岗放权
                        if (data.type === 'PreJobPhotoImport') {
                            Bus.$emit('jobPhotoSuccess');
                        }

                        if (['Video', 'Audio'].includes(data.type)) {
                            Bus.$emit('transcodeSuccess');
                        }
                    })

                    // 监听消息总数
                    this.wsBrowser.on('BadgeRefreshed', message => {
                        console.log(`%c ${message} `, 'background:#f90;color:#fff')
                        this.total = message
                    })
                })
            },

            // 获取全部消息列表
            getNoticeList() {
                api.getNoticeLongTask(this.queryData)
                    .then(res => {
                        console.log(res)
                        if (res.result) {
                            this.notices = res.package
                            this.total = res.total
                        }
                    })
                    .catch(err => console.log(err))
            },
            //获取消息盒子总数初始值
            getNoticeAmount() {
                api.getUnAcknowledgeCount({})
                    .then(res => {
                        if (res.result) {
                            this.total = res.package
                        }
                    })
                    .catch(err => console.log(err))
            },
            //确认消息
            confirmNotice(notice, index) {
                api.confirmNotification(notice.id).then(res => {
                    if (res.result) {
                        this.notices.splice(index, 1)
                        this.total -= 1
                        this.updatePageNo()
                    }
                })
            },
            emptyNotice() {
                let ids = this.noticeList.map(item => item.id)
                api.deleteNotification({ids}).then(res => {
                    if (res.result) {
                        this.notices.splice(0, 5)
                        this.total = Math.max(this.total - 5, 0)
                    }
                })
            },
            updatePageNo () {
                if (Math.ceil(this.total / 5) < this.queryData.PageNO) {
                    this.queryData.PageNO = Math.max(1, this.queryData.PageNO - 1)
                }
            },
            //改变当前页
            currentChange (currentPage) {
                this.queryData.PageNO = currentPage
            }
        },
        beforeDestroy () {
            this.$store.commit('stopWSBrowser')
        }
    }
</script>
